<template>
    <div>
        <CRow class="mb-3 search-panel">
            <CCol sm="3" md="3" xl="2" xs="12">
                <BaseInput :options="codeInput.options" :data="codeInput.data" :listener="codeInput.listener" />
            </CCol>
            <CCol sm="3" md="3" xl="2" xs="12">
                <BaseInput :options="nameInput.options" :data="nameInput.data" :listener="nameInput.listener" />
            </CCol>
            <CCol sm="3" md="3" xl="2" xs="12">
                <BaseInput :options="manufacturerCodeInput.options" :data="manufacturerCodeInput.data"
                    :listener="manufacturerCodeInput.listener" />
            </CCol>
            <CCol sm="3" md="3" xl="2" xs="12">
                <BaseInput :options="manufacturerNameInput.options" :data="manufacturerNameInput.data"
                    :listener="manufacturerNameInput.listener" />
            </CCol>
            <CCol>
                <div class="form-group">
                    <label style="color: white"></label>
                    <div style="margin-top: 10px">
                        <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
                            class="btn-action-primary" @click="loadDataMainTable(true)">
                            <i class="fa fa-refresh"></i>&nbsp;Tải lại
                        </CButton>
                        <CButton style="float: right;;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Thêm mới'"
                            class="btn-action-primary" @click="clickAdd()">
                            <i class="fa fa-plus"></i>&nbsp;Thêm mới
                        </CButton>
                        <!-- <CButton style="float: right;" color="success" v-c-tooltip.hover="'Import'"
                            class="btn-action-primary" @click="setupImport()">
                            <i class="fa fa-download"></i>&nbsp; Import
                        </CButton> -->
                    </div>
                </div>
            </CCol>
        </CRow>
        <CCard class="content-fade-in mt-3p5">
            <CCardBody>
                <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
                    ref="mainTable">
                    <template #index="{ index }">
                        <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
                    </template>

                    <template #createDate="{ item }">
                        <td v-if="item.createDate != null">
                            {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
                        </td>
                        <td v-else></td>
                    </template>

                    <template #updateDate="{ item }">
                        <td v-if="item.updateDate != null">
                            {{ $helper.formatDateDDMMYYYYHHMM(item.updateDate) }}
                        </td>
                        <td v-else></td>
                    </template>

                    <template #action="{ item }">
                        <td class="action-btn-group">
                            <div class="action-btn-wrapper">
                                <CButton color="info" variant="outline" v-c-tooltip.hover="'Cập nhật'" square size="sm"
                                    @click="loadById(item.id)">
                                    <CIcon name="cil-pencil" />
                                </CButton>
                                <CButton color="danger" variant="outline" class="ml-1" square size="sm"
                                    v-c-tooltip.hover="'Xóa'"
                                    @click="setupSelectOneAction('delete_one', item.id, item.supplierName)">
                                    <CIcon name="cil-trash" />
                                </CButton>
                            </div>
                        </td>
                    </template>
                </BaseTable>
            </CCardBody>
        </CCard>

        <CModal :title="dataSave.idField.data.model ? 'Cập nhật NCC' : 'Thêm mới NCC'" :show.sync="isShowModal"
            :closeOnBackdrop="false">
            <CRow class="pb-2">
                <CCol sm="12" md="12" xl="12" xs="12">
                    <BaseInput :options="dataSave.codeInput.options" :data="dataSave.codeInput.data"
                        :listener="dataSave.codeInput.listener" />
                    <BaseInput :options="dataSave.nameInput.options" :data="dataSave.nameInput.data"
                        :listener="dataSave.nameInput.listener" />
                    <BaseInput :options="dataSave.manufacturerCodeInput.options"
                        :data="dataSave.manufacturerCodeInput.data"
                        :listener="dataSave.manufacturerCodeInput.listener" />
                    <BaseInput :options="dataSave.manufacturerNameInput.options"
                        :data="dataSave.manufacturerNameInput.data"
                        :listener="dataSave.manufacturerNameInput.listener" />
                </CCol>
            </CRow>
            <template v-slot:footer>
                <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i>
                    Hủy bỏ
                </button>
                <button type="button" class="btn btn-primary" @click="submitData()"><i class="fa"
                        :class="dataSave.idField.data.model ? 'fa-save' : 'fa-save'"></i>
                    {{ dataSave.idField.data.model ? 'Lưu lại' : 'Lưu lại' }}
                </button>
            </template>
        </CModal>

        <CModal v-if="dataImport.isShowModal" :title="'Import NCC'" :show.sync="dataImport.isShowModal"
            :closeOnBackdrop="false">
            <CRow class="pb-2">
                <CCol sm="12" md="12" xl="12" xs="12" class="form-group">
                    <div class="form-input-wrapper">
                        <label class="form-label" for="uploadFile">Chọn tệp tin<span class='required'> *</span></label>
                        <div class="custom-file"
                            :class="dataImport.selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                            <input type="file" class="custom-file-input" id="uploadFile" ref="file"
                                :accept="dataImport.selectedFiles.options.acceptFile" @change="selectFile($event)">
                            <label class="custom-file-label" for="uploadFile">{{
                                dataImport.selectedFiles.options.fileName
                                }}
                                <i v-if="dataImport.selectedFiles.data.loading" class="fa fa-spinner fa-spin"
                                    style="position: absolute; right: 100px;font-size: 20px;top: 8px;"></i>
                            </label>
                        </div>
                        <div class="valid-error"
                            v-show="!(dataImport.selectedFiles.data.validator ? dataImport.selectedFiles.data.validator.isValid : true)">
                            {{ dataImport.selectedFiles.data.validator ?
                                dataImport.selectedFiles.data.validator.errorMessage : "" }}
                        </div>
                    </div>
                </CCol>
            </CRow>
            <template v-slot:footer>
                <button type="button" class="btn btn-secondary" @click="dataImport.isShowModal = false"><i
                        class="fa fa-times"></i> Hủy bỏ
                </button>
                <button type="button" class="btn btn-primary" @click="submitImport()"><i class="fa"
                        :class="'fa-upload'"></i> Thực
                    hiện
                </button>
            </template>
        </CModal>

        <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
    </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import ModalConfirm from "../base/BaseModalConfirm";

export default {
    name: "ConfigSupplierList",
    components: {
        BaseSwitch,
        BaseTable,
        BaseInput,
        BaseSelect,
        ModalConfirm
    },
    notifications: {
        showSuccessMsg: {
            type: "success",
            title: "Success"
        },
        showErrorMsg: {
            type: "error",
            title: "Error"
        },
        showWarningMsg: {
            type: "warn",
            title: "warn"
        }
    },
    data() {
        let that = this;

        let actionTypeMapping = new Map();

        actionTypeMapping.set("delete_one", {
            url: "/supplier/deleteById",
            titlePopup: function () {
                return that.$helper.setupTitleAction(
                    "xóa",
                    "NCC",
                    that.actionData.model.name
                );
            },
            isJsonContentType: false,
            dataSubmit: function () {
                return {
                    id: that.actionData.model.id,
                };
            },
            successCallback: function () {
                that.showSuccessMsg({ message: "Xóa NCC " + that.actionData.model.name + " thành công" });
                that.loadDataMainTable();
            }
        });

        return {
            isShowModal: false,
            actionData: {
                actionTypeMapping: actionTypeMapping,
                model: {
                    selectedAll: false,
                    id: null,
                    name: null
                }
            },
            dataImport: {
                isShowModal: false,
                selectedFiles: {
                    options: {
                        fileName: 'Chọn tệp Excel',
                        acceptFile: ".xlsx, .xls",
                    },
                    data: {
                        loading: false,
                        name: "file",
                        model: {
                            fileName: '',
                            content: '',
                            size: '',
                            type: ''
                        },
                        validator: {
                            isValid: true,
                            errorMessage: "",
                            valid: function () {
                                this.isValid = that.validateFile();
                                return this.isValid;
                            }
                        }
                    }
                },
            },
            parentCode: "",
            dataSave: {
                idField: {
                    data: {
                        name: "id",
                        model: ""
                    }
                },
                codeInput: {
                    options: {
                        label: "Mã NCC <span class='required'>*</span>",
                        placeholder: "Mã NCC",
                    },
                    data: {
                        name: "supplierCode",
                        model: "",
                        updateCallback: function () {
                            that.submitData();
                        },
                        validator: {
                            isValid: true,
                            errorMessage: "",
                            valid: function () {
                                let value = that.dataSave.codeInput.data.model;
                                if (value === "") {
                                    this.isValid = false;
                                    this.errorMessage = "Mã NCC không được để trống";
                                } else if (value.length > 64) {
                                    this.isValid = false;
                                    this.errorMessage = "Mã NCC được quá 64 kí tự";
                                } else {
                                    this.isValid = true;
                                }
                                return this.isValid;
                            }
                        }
                    }
                },
                nameInput: {
                    options: {
                        label: "Tên NCC <span class='required'>*</span>",
                        placeholder: "Tên NCC",
                    },
                    data: {
                        name: "supplierName",
                        model: "",
                        updateCallback: function () {
                            that.submitData();
                        },
                        validator: {
                            isValid: true,
                            errorMessage: "",
                            valid: function () {
                                let value = that.dataSave.nameInput.data.model;
                                if (value === "") {
                                    this.isValid = false;
                                    this.errorMessage = "Tên NCC không được để trống";
                                } else if (value.length > 64) {
                                    this.isValid = false;
                                    this.errorMessage = "Tên NCC được quá 64 kí tự";
                                } else {
                                    this.isValid = true;
                                }
                                return this.isValid;
                            }
                        }
                    }
                },
                manufacturerCodeInput: {
                    options: {
                        label: "Mã nhà sản xuất <span class='required'>*</span>",
                        placeholder: "Mã nhà sản xuất",
                    },
                    data: {
                        name: "manufacturerCode",
                        model: "",
                        updateCallback: function () {
                            that.submitData();
                        },
                        validator: {
                            isValid: true,
                            errorMessage: "",
                            valid: function () {
                                let value = that.dataSave.manufacturerCodeInput.data.model;
                                if (value === "") {
                                    this.isValid = false;
                                    this.errorMessage = "Mã nhà sản xuất không được để trống";
                                } else if (value.length > 64) {
                                    this.isValid = false;
                                    this.errorMessage = "Mã nhà sản xuất được quá 64 kí tự";
                                } else {
                                    this.isValid = true;
                                }
                                return this.isValid;
                            }
                        }
                    }
                },
                manufacturerNameInput: {
                    options: {
                        label: "Tên nhà sản xuất <span class='required'>*</span>",
                        placeholder: "Tên nhà sản xuất",
                    },
                    data: {
                        name: "manufacturerName",
                        model: "",
                        updateCallback: function () {
                            that.submitData();
                        },
                        validator: {
                            isValid: true,
                            errorMessage: "",
                            valid: function () {
                                let value = that.dataSave.manufacturerNameInput.data.model;
                                if (value === "") {
                                    this.isValid = false;
                                    this.errorMessage = "Tên nhà sản xuất không được để trống";
                                } else if (value.length > 64) {
                                    this.isValid = false;
                                    this.errorMessage = "Tên nhà sản xuất được quá 64 kí tự";
                                } else {
                                    this.isValid = true;
                                }
                                return this.isValid;
                            }
                        }
                    }
                },
            },
            codeInput: {
                options: {
                    placeholder: "Mã NCC",
                    label: 'Mã NCC'
                },
                data: {
                    name: "supplierCode",
                    model: "",
                    updateTrigger: function () {
                        return that.$refs.mainTable;
                    }
                }
            },
            nameInput: {
                options: {
                    placeholder: "Tên NCC",
                    label: 'Tên NCC'
                },
                data: {
                    name: "supplierName",
                    model: "",
                    updateTrigger: function () {
                        return that.$refs.mainTable;
                    }
                }
            },
            manufacturerCodeInput: {
                options: {
                    placeholder: "Mã nhà sản xuất",
                    label: 'Mã nhà sản xuất'
                },
                data: {
                    name: "manufacturerCode",
                    model: "",
                    updateTrigger: function () {
                        return that.$refs.mainTable;
                    }
                }
            },
            manufacturerNameInput: {
                options: {
                    placeholder: "Tên nhà sản xuất",
                    label: 'Tên nhà sản xuất'
                },
                data: {
                    name: "manufacturerName",
                    model: "",
                    updateTrigger: function () {
                        return that.$refs.mainTable;
                    }
                }
            },
            mainTable: {
                options: {
                    fields: [
                        { key: "index", label: "STT", sorter: false, filter: false },
                        { key: "createDate", label: "Ngày tạo" },
                        { key: "updateDate", label: "Cập nhật cuối" },
                        { key: "supplierCode", label: "Mã NCC" },
                        { key: "supplierName", label: "Tên NCC" },
                        { key: "manufacturerCode", label: "Mã NSX" },
                        { key: "manufacturerName", label: "Tên NSX" },
                        { key: "action", label: "Thao tác", sorter: false, filter: false }
                    ],
                    slots: [
                        "index", "createDate", "updateDate", "action"
                    ],
                    pageSize: 20,
                    sorter: true,
                    columnFilter: false,
                    itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
                    tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
                },
                dataSource: {
                    url: "/supplier/getPages",
                    dataSubmit: function () {
                        var params = that.$helper.setupDataSubmit(that.$data);
                        return params;
                    },
                    response: function (dataResponse) {
                        return dataResponse.data;
                    },
                },
            },
        }
    },
    methods: {
        loadDataMainTable: function (isUpdateFilter) {
            this.$refs.mainTable.loadData(true, isUpdateFilter);
        },
        clickAdd() {
            this.isShowModal = true;
            this.dataSave.idField.data.model = "";
            this.dataSave.codeInput.data.model = "";
            this.dataSave.nameInput.data.model = "";
            this.dataSave.manufacturerCodeInput.data.model = "";
            this.dataSave.manufacturerNameInput.data.model = "";
            this.parentCode = "";
        },
        loadById(id) {
            let that = this;
            this.$helper.loadDataSource({
                loading: that.loading,
                url: "/supplier/find-by-id",
                isJsonContentType: false,
                dataSubmit: function () {
                    return { id: id }
                },
                successCallback: function (response) {
                    that.isShowModal = true;
                    that.$helper.setupDataResponse(that.$data.dataSave, response.data.data);
                },
                errorCallback: function (error) {
                    that.$helper.handleError(that.$router, error);
                }
            });
        },
        submitData() {
            let that = this;
            let urlSubmit = "/supplier/create";
            if (this.dataSave.idField.data.model) {
                urlSubmit = "/supplier/update";
            }
            this.$helper.loadDataSource({
                loading: that.loading,
                url: urlSubmit,
                dataRef: function () {
                    return that.$data.dataSave;
                },
                successCallback: function (response) {
                    if (!that.$helper.validResponse(that.$router, response.data)) {
                        that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
                        that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
                    } else {
                        that.showSuccessMsg({ message: that.dataSave.idField.data.model ? "Cập nhật NCC thành công" : "Thêm mới NCC thành công" });
                        that.isShowModal = false
                        that.loadDataMainTable()
                    }
                },
                errorCallback: function (error) {
                    that.$helper.handleError(that.$router, error);
                }
            });
        },
        setupImport() {
            this.dataImport.isShowModal = true;
        },
        selectFile() {
            let that = this;
            let reader = new FileReader();
            let file = this.$refs.file;
            if (file && file.files[0]) {
                file = file.files[0];
                this.dataImport.selectedFiles.data.loading = true;
                reader.readAsDataURL(file);

                reader.onload = function () {
                    that.dataImport.selectedFiles.options.fileName = file.name;
                    that.validateFile(file.type, file.size);
                    that.dataImport.selectedFiles.data.model.size = file.size;
                    that.dataImport.selectedFiles.data.model.fileName = file.name;
                    that.dataImport.selectedFiles.data.model.type = file.type;
                }
                reader.onloadend = function () {
                    that.dataImport.selectedFiles.data.loading = false;
                }
            } else {
                that.dataImport.selectedFiles.options.fileName = "Chọn tệp";
                that.dataImport.selectedFiles.data.model.size = "";
                that.dataImport.selectedFiles.data.model.fileName = "";
                that.dataImport.selectedFiles.data.model.type = "";
                that.validateFile();
            }
        },
        validateFile(type, size) {
            let isValid = true;
            if ((type && type != undefined) && (size && size != undefined)) {
                isValid = this.validateFileType(type, size);
            } else {
                if (this.dataImport.selectedFiles.data.model.type && this.dataImport.selectedFiles.data.model.size) {
                    isValid = this.validateFileType(this.dataImport.selectedFiles.data.model.type, this.dataImport.selectedFiles.data.model.size);
                } else {
                    if (this.dataImport.selectedFiles.data.model.fileName === '') {
                        this.dataImport.selectedFiles.data.validator.isValid = false;
                        this.dataImport.selectedFiles.data.validator.errorMessage = "Tệp tin không được để trống";
                        isValid = false;
                    }
                }
            }
            return isValid;
        },
        validateFileType(type, size) {
            let isValid = true;
            if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || type === "application/vnd.ms-excel") {
                this.dataImport.selectedFiles.data.validator.isValid = true;
                this.dataImport.selectedFiles.data.validator.errorMessage = "";
            } else {
                this.dataImport.selectedFiles.data.validator.isValid = false;
                this.dataImport.selectedFiles.data.validator.errorMessage = "Sai định dạng tệp tin";
                isValid = false;
            }
            return isValid;
        },
        submitImport() {
            let that = this;
            let isValid = true;
            isValid &= this.dataImport.selectedFiles.data.validator.valid();
            if (!isValid) {
                return;
            }
            that.loading.value = true;
            let formData = new FormData();
            formData.append("file", that.$refs.file.files[0]);

            that.$helper.loadDataSource({
                url: "/supplier/import",
                dataSubmit: function () {
                    return formData;
                },
                isMultiPartFormData: true,
                successCallback: function (response) {
                    if (!that.$helper.validResponse(that.$router, response.data)) {
                        that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
                        that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
                    } else {
                        that.showSuccessMsg({ message: "Import NCC thành công" });
                    }
                    that.dataImport.isShowModal = false;

                    that.loading.value = false;
                    that.dataImport.selectedFiles.options.fileName = "Chọn tệp";
                    that.dataImport.selectedFiles.data.model.size = "";
                    that.dataImport.selectedFiles.data.model.fileName = "";
                    that.dataImport.selectedFiles.data.model.type = "";
                    that.loadDataMainTable();
                },
                errorCallback: function (error) {
                    that.$helper.handleError(that.$router, error);
                    that.loading.value = false
                }
            });
        },
        setupSelectOneAction: function (actionTypeKey, id, name) {
            let actionData = this.actionData.model;
            actionData.id = id || null;
            actionData.name = name || null;
            this.$refs.actionModal.setCurrAction(actionTypeKey);
        },
    },
    created: function () {
    },
    mounted() {
    },
    watch: {
    },
    computed: {}
};
</script>
<style scoped></style>